export enum PaymentTransactionStatus {
  Successful,
  Pending,
  Failed,
}
